import { inject, Injectable } from '@angular/core';
import { UserIdentification, UsersId } from '@models/swagger';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { UsersIdFailure, UsersIdRequest, UsersIdSuccess } from './actions';
import { UsersIdParams, UsersIdService } from './service';

@Injectable()
export class UsersIdEffects {
  private readonly actions$ = inject(Actions);
  private readonly usersIdService = inject(UsersIdService);

  usersId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsersIdRequest),
      switchMap(({ body, parameters }: { body: UsersId; parameters?: UsersIdParams }) =>
        this.usersIdService.usersId(body, parameters).pipe(
          map((data: UserIdentification) => UsersIdSuccess({ data })),
          catchError(error => of(UsersIdFailure({ error })))
        )
      )
    )
  );

}
